module.exports = __webpack_public_path__ + "static/media/mobile-footer-bg-2.b5dfa19d.svg";